// import { createSelector } from 'reselect'

const getState = state => state.snackbar
const snackbarStateSelector = state => getState(state).open
const snackbarMessageSelector = state => getState(state).message
const snackbarTypeSelector = state => getState(state).type

export {
  snackbarStateSelector,
  snackbarMessageSelector,
  snackbarTypeSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/SnackbarSelectors.js